// import { all, call, put, takeEvery, select } from 'redux-saga/effects';
// import {
//   defineKqlQuery,
//   fetchForms,
//   searchSubmissions,
// } from '@kineticdata/react';
// import { C } from '@kineticdata/bundle-common';
// import { actions, types } from '../modules/servicesApp';

export function* watchServicesApp() {}
